module.exports = __webpack_public_path__ + "Flag-68.eb208f624c5108d202d4dbe1180ac17e.svg";